import type { FaireProductEntity } from "../../entity_types/product";

export const p_9cytpfywtd: FaireProductEntity = {
  token: "p_9cytpfywtd",
  type: "product",
  name: "Vintage Mini Silver Oval Locket Necklace",
  brandToken: "b_2yc6uznjzg",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/1d7b8bd1e414e88ea6afcbe31c21c0a1b8965d5e439f6f4f639e78ec0bf7dbb7.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/dc3e03b78b0bcec7a8e6f46b3fc3dd8e3b349b110d8ff53c72585b0ceb906a30.jpeg",
    "https://cdn.faire.com/fastly/360644ee49e132b159237a2e360433959274d65208a4ff3f170a5cd464e67400.jpeg",
    "https://cdn.faire.com/fastly/19fcc47416ee07cf85c448710988846952947cf2efd3d61c15ec7970df0da4e7.jpeg",
  ],
  priceDollars: 22.17,
  description:
    "Deadstock vintage small oval locket with elegant floral embossing. Comes on a hypoallergenic, 100% recycled sterling silver cable chain. Locket opens! These may have some slight tarnishing/wear on the inside (can be covered by a photo placed in them). \n\nAll materials are sustainable, eco friendly, and ethically sourced. Vintage charms may have some signs of wear, but that's just what gives them character :)\n\n16\" chain\n16x11mm locket",
  tags: [],
  msrpDollars: 44.34,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:02.901Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
